import angular from 'angular';
import agentDownloadLinkComponent from './agentDownloadLink.component';

let agentDownloadLinkModule = angular.module('agentDownloadLink', []).directive('agentDownloadLink', agentDownloadLinkComponent);

export default agentDownloadLinkModule;



// WEBPACK FOOTER //
// ./app/components/agentDownloadLink/agentDownloadLink.js